export function CustomizePanel() {
  return (
    <aside className="panel panel-right">
      <h2>Customize</h2>
      <div className="chart-type-strip">
        <label htmlFor="chartType" className="chart-type-label">
          Chart type
        </label>
        <select id="chartType" className="chart-type-select" defaultValue="scatter">
          <option value="scatter">Scatter</option>
          <option value="line">Line</option>
          <option value="bar">Bar</option>
        </select>
      </div>
      <div className="customize-tabs" role="tablist">
        <button type="button" className="custom-tab-btn active" role="tab" aria-selected="true" data-tab="axis">
          Axis
        </button>
        <button type="button" className="custom-tab-btn" role="tab" aria-selected="false" data-tab="style">
          Style
        </button>
        <button type="button" className="custom-tab-btn" role="tab" aria-selected="false" data-tab="export">
          Export
        </button>
      </div>
      <div className="panel-content">
        <div id="tab-axis" className="custom-tab-panel active" role="tabpanel">
          <div className="custom-block">
            <h3>Axis range</h3>
            <div className="field inline">
              <label>X min</label>
              <input type="number" id="xMin" placeholder="auto" min="-1000000" max="1000000" step="any" title="Axis min/max (slider is coarse; type exact values if needed)" />
            </div>
            <div className="field inline">
              <label>X max</label>
              <input type="number" id="xMax" placeholder="auto" min="-1000000" max="1000000" step="any" title="Axis min/max (slider is coarse; type exact values if needed)" />
            </div>
            <div className="field inline">
              <label>Y min</label>
              <input type="number" id="yMin" placeholder="auto" min="-1000000" max="1000000" step="any" title="Axis min/max (slider is coarse; type exact values if needed)" />
            </div>
            <div className="field inline">
              <label>Y max</label>
              <input type="number" id="yMax" placeholder="auto" min="-1000000" max="1000000" step="any" title="Axis min/max (slider is coarse; type exact values if needed)" />
            </div>
            <button type="button" className="btn btn-small" id="applyRangeBtn">
              Apply range
            </button>
          </div>
          <div className="custom-block">
            <h3>Axis labels</h3>
            <div className="field">
              <label htmlFor="xLabel">X label</label>
              <input type="text" id="xLabel" placeholder="X axis" />
            </div>
            <div className="field">
              <label htmlFor="yLabel">Y label</label>
              <input type="text" id="yLabel" placeholder="Y axis" />
            </div>
            <button type="button" className="btn btn-small" id="applyLabelsBtn">
              Apply labels
            </button>
          </div>
          <div className="custom-block" id="panelLayoutBlock">
            <h3>Panel layout (multigraph)</h3>
            <div className="field inline">
              <label htmlFor="panelRows">Rows</label>
              <input type="number" id="panelRows" min="1" max="6" defaultValue="1" title="1–6" />
            </div>
            <div className="field inline">
              <label htmlFor="panelCols">Cols</label>
              <input type="number" id="panelCols" min="1" max="6" defaultValue="1" title="1–6" />
            </div>
            <p className="hint small">
              Grid size 1×1 = single plot. For multiple panels, use the checkboxes to assign <strong>one or more</strong> Y series to each panel. Axes are shared and auto-fit to the plotted data.
            </p>
            <div id="panelAssignmentContainer" className="panel-assignment" hidden />
          </div>
          <div className="custom-block">
            <h3>Log scale</h3>
            <label className="checkbox-label">
              <input type="checkbox" id="xLogScale" /> X log scale
            </label>
            <label className="checkbox-label">
              <input type="checkbox" id="yLogScale" /> Y log scale
            </label>
          </div>
          <div className="custom-block">
            <h3>Ratio plot</h3>
            <button type="button" className="btn btn-small" id="toggleRatioBtn">
              Show ratio plot
            </button>
            <div className="field">
              <label htmlFor="ratioNumerator">Numerator series</label>
              <select id="ratioNumerator" />
            </div>
            <div className="field">
              <label htmlFor="ratioDenominator">Denominator series</label>
              <select id="ratioDenominator" />
            </div>
            <div className="field">
              <label htmlFor="ratioAxisTitle">Ratio Y label</label>
              <input type="text" id="ratioAxisTitle" placeholder="Ratio" />
            </div>
            <div className="field inline">
              <label htmlFor="ratioAxisYMin">Ratio Y min</label>
              <input type="number" id="ratioAxisYMin" placeholder="auto" min="-1000000" max="1000000" step="any" title="Ratio axis range (slider is coarse; type exact values if needed)" />
            </div>
            <div className="field inline">
              <label htmlFor="ratioAxisYMax">Ratio Y max</label>
              <input type="number" id="ratioAxisYMax" placeholder="auto" min="-1000000" max="1000000" step="any" title="Ratio axis range (slider is coarse; type exact values if needed)" />
            </div>
            <p className="hint small">
              Use the button to show or hide the ratio panel. Choose any two plotted Y series. Shared X with the main plot (one axis at the bottom). Change series or Y range anytime, then Apply range or Plot to refresh.
            </p>
          </div>
          <div className="custom-block root-options-block" id="rootOptionsBlock" hidden>
            <h3>ROOT options</h3>
            <label className="checkbox-label">
              <input type="checkbox" id="rootNormalize" /> Normalize to area = 1
            </label>
            <label className="checkbox-label">
              <input type="checkbox" id="rootStack" /> Stack series
            </label>
          </div>
        </div>
        <div id="tab-style" className="custom-tab-panel" role="tabpanel" hidden>
          <div className="custom-block">
            <h3>Canvas size</h3>
            <p className="hint small">Leave empty for auto (fills panel). Set both to fix plot dimensions.</p>
            <div className="field inline">
              <label htmlFor="canvasWidth">Width (px)</label>
              <input type="number" id="canvasWidth" min="200" max="4000" placeholder="auto" defaultValue="" title="200–4000 or empty for auto" />
            </div>
            <div className="field inline">
              <label htmlFor="canvasHeight">Height (px)</label>
              <input type="number" id="canvasHeight" min="200" max="4000" placeholder="auto" defaultValue="" title="200–4000 or empty for auto" />
            </div>
            <button type="button" className="btn btn-small" id="applyCanvasSizeBtn">
              Apply
            </button>
          </div>
          <div className="custom-block">
            <h3>Grid & font</h3>
            <div className="field field-inline-row">
              <label htmlFor="tickDivisions">N divisions (max ticks per axis)</label>
              <input type="number" id="tickDivisions" min="2" max="50" placeholder="auto" defaultValue="" title="Leave empty for auto" />
            </div>
            <div className="field field-inline-row">
              <label htmlFor="subTicks">Sub-ticks between majors</label>
              <select id="subTicks" defaultValue="0" title="Number of minor tick marks between each pair of major ticks">
                <option value="0">None</option>
                <option value="2">2</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="10">10</option>
              </select>
            </div>
            <label className="checkbox-label">
              <input type="checkbox" id="gridX" /> Show X grid
            </label>
            <label className="checkbox-label">
              <input type="checkbox" id="gridY" /> Show Y grid
            </label>
            <div className="field inline">
              <label htmlFor="axisLabelSize">Axis label size</label>
              <select id="axisLabelSize" defaultValue="12">
                <option value="10">10</option>
                <option value="11">11</option>
                <option value="12">12</option>
                <option value="14">14</option>
                <option value="16">16</option>
              </select>
            </div>
            <div className="field inline">
              <label htmlFor="tickSize">Tick size</label>
              <select id="tickSize" defaultValue="11">
                <option value="9">9</option>
                <option value="10">10</option>
                <option value="11">11</option>
                <option value="12">12</option>
                <option value="14">14</option>
              </select>
            </div>
            <div className="field">
              <label htmlFor="axisAlign">Axis label alignment</label>
              <select id="axisAlign" defaultValue="center">
                <option value="start">Start</option>
                <option value="center">Center</option>
                <option value="end">End</option>
              </select>
            </div>
            <div className="field field-inline-row">
              <label htmlFor="tickOffsetX">Tick number offset X (px)</label>
              <input type="number" id="tickOffsetX" min="0" max="40" defaultValue="16" title="Space between axis and tick numbers on X" />
            </div>
            <div className="field field-inline-row">
              <label htmlFor="tickOffsetY">Tick number offset Y (px)</label>
              <input type="number" id="tickOffsetY" min="-20" max="40" defaultValue="-8" title="Space between axis and tick numbers (negative = closer to axis)" />
            </div>
            <div className="field field-inline-row">
              <label htmlFor="titleOffsetX">Axis title offset X (px)</label>
              <input type="number" id="titleOffsetX" min="0" max="40" defaultValue="14" title="Space between tick numbers and axis label on X" />
            </div>
            <div className="field field-inline-row">
              <label htmlFor="titleOffsetY">Axis title offset Y (px)</label>
              <input type="number" id="titleOffsetY" min="0" max="40" defaultValue="18" title="Space between tick numbers and axis label on Y" />
            </div>
            <button type="button" className="btn btn-small" id="applyGridFontBtn">
              Apply
            </button>
          </div>
          <div className="custom-block">
            <h3>Line & series</h3>
            <p className="hint small">Line/series color and line style only. Marker color is in Marker section.</p>
            <div id="seriesColors" className="series-colors" />
          </div>
          <div className="custom-block chart-option-block" id="xyDisplayBlock" style={{ display: 'none' }}>
            <h3>Line &amp; markers</h3>
            <p className="hint small">Works for both line and scatter charts. Toggle line and markers independently.</p>
            <label className="checkbox-label">
              <input type="checkbox" id="plotShowLine" /> Show line
            </label>
            <label className="checkbox-label">
              <input type="checkbox" id="plotShowMarkers" defaultChecked /> Show markers
            </label>
            <div className="field field-inline-row line-width-row">
              <label htmlFor="lineWidthScatter">Line width</label>
              <select id="lineWidthScatter" defaultValue="2">
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="8">8</option>
              </select>
              <input type="range" id="lineWidthScatterRange" min="1" max="8" defaultValue="2" step="1" className="inline-range" title="Line width" aria-label="Line width" />
            </div>
          </div>
          <div className="custom-block" id="markerBlock">
            <h3>Marker</h3>
            <p className="hint small">Marker style, size, and color only. Line color is in Line & series.</p>
            <div id="seriesMarkers" className="series-markers" />
          </div>
          <div className="custom-block">
            <h3>Legend</h3>
            <label className="checkbox-label">
              <input type="checkbox" id="legendShow" defaultChecked /> Show legend
            </label>
            <div className="field">
              <label htmlFor="legendPosition">Position</label>
              <select id="legendPosition" defaultValue="top">
                <option value="top">Top</option>
                <option value="bottom">Bottom</option>
                <option value="left">Left</option>
                <option value="right">Right</option>
              </select>
            </div>
            <div className="field">
              <label>Legend labels (edit text)</label>
              <div id="legendLabels" className="legend-labels" />
            </div>
          </div>
          <div className="custom-block">
            <h3>Chart text</h3>
            <div className="field">
              <label htmlFor="chartTitle">Title</label>
              <input type="text" id="chartTitle" placeholder="Plot title" />
            </div>
            <div className="field">
              <label htmlFor="chartSubtitle">Subtitle / note</label>
              <input type="text" id="chartSubtitle" placeholder="Optional subtitle" />
            </div>
            <button type="button" className="btn btn-small" id="applyTextBtn">
              Apply text
            </button>
          </div>
        </div>
        <div id="tab-export" className="custom-tab-panel" role="tabpanel" hidden>
          <div className="custom-block">
            <h3>Export</h3>
            <div className="field">
              <label htmlFor="exportPreset">Preset (for manuscript/slides)</label>
              <select id="exportPreset" defaultValue="screen">
                <option value="screen">Screen (current size)</option>
                <option value="manuscript1">Manuscript 1-column (~85 mm)</option>
                <option value="manuscript2">Manuscript 2-column (~175 mm)</option>
                <option value="slide">Slide (~10 in width)</option>
              </select>
            </div>
            <div className="btn-row">
              <button type="button" className="btn btn-export" id="exportPng">
                PNG
              </button>
              <button type="button" className="btn btn-export" id="exportJpeg">
                JPEG
              </button>
              <button type="button" className="btn btn-export" id="exportPdf">
                PDF
              </button>
            </div>
            <div className="custom-block">
              <h3>Python / Matplotlib</h3>
              <p className="hint small">Generate a runnable Python script that reproduces this plot. Edit and run locally.</p>
              <button type="button" className="btn btn-secondary" id="downloadPythonBtn">
                Download Python script
              </button>
            </div>
          </div>
        </div>
      </div>
    </aside>
  );
}
